import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

import { MESSAGING_LABEL_FONT_WEIGHT } from '~pages/Messages/messagingTypography';
import { hexToRgba } from '~utils/utilFunctions';

type MessagingTagTone = 'emphasized' | 'info' | 'neutral';

type MessagingTagProps = {
  icon?: ReactNode;
  label: string;
  testId?: string;
  tone: MessagingTagTone;
};

export default function MessagingTag({ icon, label, testId, tone }: MessagingTagProps) {
  const theme = useTheme();
  const toneStyles = {
    emphasized: {
      bgcolor: hexToRgba(theme.brandV2.colors.treadOrangeDark, 0.12),
      borderColor: theme.semantic.divider,
      color: theme.brandV2.colors.treadOrangeDark,
    },
    info: {
      bgcolor: theme.semantic.statusInfoBg,
      borderColor: theme.semantic.statusInfo,
      color: theme.semantic.statusInfo,
      fontWeight: MESSAGING_LABEL_FONT_WEIGHT,
    },
    neutral: {
      bgcolor: theme.semantic.surfaceRaised,
      borderColor: theme.semantic.divider,
      color: theme.semantic.textSecondary,
    },
  } satisfies Record<MessagingTagTone, object>;

  return (
    <Typography
      component="span"
      data-test-id={testId}
      sx={{
        alignItems: 'center',
        border: 'solid 1px',
        borderRadius: theme.brandV2.borderRadius,
        display: 'inline-flex',
        flexShrink: 0,
        fontSize: '11px',
        gap: 0.5,
        px: 0.75,
        py: 0.125,
        whiteSpace: 'nowrap',
        ...toneStyles[tone],
      }}
    >
      {icon}
      {label}
    </Typography>
  );
}
